/*
  Volta pack builder — assets/product-bundle.js (v2.2, 05/10/2026; v2.1 = drawer pedido com o prefixo do idioma;
  v2.2 = eventos Microsoft Clarity pack_qty_changed, pack_slot_edit, pack_added, pack_blocked, pack_error, sem efeito
  se a Clarity não estiver instalada). Substitui a versão da AUGE.

  O que muda face à versão anterior:
  - Tocar numa cor nunca abre pop-up: muda a imagem grande (pré-visualização sobre a galeria, sem tocar
    nas miniaturas) e a cor do(s) slot(s).
  - Os slots nascem preenchidos com a cor à vista. Enquanto a cliente não tocar num slot, cada cor
    muda todos (modo uniforme). Tocar num slot torna-o o ativo e, a partir daí, a cor muda só esse.
  - Com 1 unidade não há slots visíveis nem "Selected Items".
  - Nunca há slots vazios, logo não há "Remove".

  O contrato do DOM que o botão de compra lê mantém-se: .fake_item_shape > .slot-swatches >
  .slot-swatch-circle[data-option-pos][data-option-value], com data-product_var no .slot-swatches.
  Tudo o resto (variantes >250 via Storefront API, disponibilidade, selects de tamanho, add to cart)
  é o código original da AUGE.
*/
// Medição (Microsoft Clarity): marca as sessões para filtrar gravações. Sem Clarity não faz nada.
const voltaTracked = {};
function voltaTrack(name, key, value) {
  try { if (typeof window.clarity !== 'function') return; if (key) window.clarity('set', key, String(value)); window.clarity('event', name); } catch (e) {}
}
function voltaTrackOnce(id, name, key, value) { if (voltaTracked[id]) return; voltaTracked[id] = 1; voltaTrack(name, key, value); }

const popUppp = document.querySelector('.buy_more_save_more');
function buyMore() {
  if (popUppp) { popUppp.classList.toggle('active'); }
}
function hideBuyMore() {
  if (popUppp) { popUppp.classList.remove('active'); }
}
document.querySelectorAll('.buy_more_save_more .Qty__buttons').forEach(button => {
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    document.querySelector('.buy_more_save_more').classList.remove('active');
  });
});
document.addEventListener('click', function (e) {
  const popup = document.querySelector('.buy_more_save_more');
  const opener = document.querySelector('.pop_up_opener_buy_more_save_more');
  if (popup && opener) {
    if (!popup.contains(e.target) && !opener.contains(e.target)) { hideBuyMore(); }
  }
});

function updatePrices(activeElement) {
  function fmt(cents) {
    const format = window.bundleMoneyFormat || '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString())
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount}}', amount);
  }
  const compare_price = parseFloat(activeElement.dataset.compare_price);
  const original_price = parseFloat(activeElement.dataset.price);
  const priceBlock = document.querySelector('.price-block');
  if (!priceBlock) return;
  const saleEl = priceBlock.querySelector('.sale-price');
  const compareEl = priceBlock.querySelector('.regular-price');
  if (saleEl) saleEl.textContent = fmt(original_price);
  if (compareEl) compareEl.textContent = fmt(compare_price);
}

document.addEventListener('DOMContentLoaded', () => {
  const bundlePack = document.querySelectorAll('.Qty__buttons');
  const qtyToCart = document.querySelector('#added_to_cart_qty');
  const selectedItemContainer = document.querySelector('.selected_item');
  const selectedItemFlex = document.querySelector('.selected_item_flex');
  const productColors = document.querySelectorAll('.variant_featured_image_bundle');
  const sectionBlock = selectedItemContainer ? selectedItemContainer.closest('.section-block') : null;
  // selectedOptions[position] = { value: string, swatchStyle: string }  (estado "atual": o que a cliente tocou por último)
  let selectedOptions = {};
  // slots[i] = { opts: {pos: value}, styles: {pos: cssText} }
  let slots = [];
  let activeSlot = 0;
  let uniform = true;

  if (!selectedItemContainer) return;

  // ---------- textos (EN / PT / DE) ----------
  const LANG = (document.documentElement.lang || 'en').toLowerCase();
  const T = LANG.indexOf('pt') === 0 ? {
    uniform1: 'Todas em {c} · toca no item 2 para outra cor',
    uniformN: 'Mesmas cores em todos os itens · toca no item 2 para mudar',
    pick: 'Toca num item e depois numa cor',
    item: 'Item',
    chooseAll: 'Seleciona primeiro as cores de todos os produtos.',
    unavailable: 'Uma das combinações de cores selecionadas não está disponível. Experimenta uma combinação diferente.',
    cartError: 'Erro ao adicionar: '
  } : LANG.indexOf('de') === 0 ? {
    uniform1: 'Alle in {c} · Artikel 2 antippen für eine andere Farbe',
    uniformN: 'Gleiche Farben für alle Artikel · Artikel 2 antippen zum Ändern',
    pick: 'Artikel antippen, dann eine Farbe',
    item: 'Artikel',
    chooseAll: 'Bitte zuerst die Farben aller Produkte wählen.',
    unavailable: 'Eine der gewählten Farbkombinationen ist nicht verfügbar. Bitte eine andere Kombination wählen.',
    cartError: 'Fehler beim Hinzufügen: '
  } : {
    uniform1: 'All in {c} · tap item 2 for a different colour',
    uniformN: 'Same colours for all items · tap item 2 to change',
    pick: 'Tap an item, then a colour',
    item: 'Item',
    chooseAll: 'Please choose the colours of every product first.',
    unavailable: 'One of the selected colour combinations is unavailable. Please try a different combination.',
    cartError: 'Error adding to cart: '
  };

  // ---------- estilos próprios (injetados aqui para a alteração ficar num só ficheiro) ----------
  const style = document.createElement('style');
  style.textContent = [
    '.volta-pack-single .volta-pack-heading,.volta-pack-single .selected_item_flex,.volta-pack-single .volta-pack-hint{display:none!important}',
    '.selected_item{gap:12px!important}',
    '.fake_item_shape{position:relative;display:flex;align-items:center;gap:6px;padding:7px 9px;border:2px solid #dde1d7;border-radius:12px;cursor:pointer;background:transparent;transition:border-color .15s ease}',
    '.fake_item_shape.is-active{border-color:#1a1a1a}',
    '.fake_item_shape index{position:absolute;left:-7px;top:-7px;width:18px;height:18px;border-radius:50%;background:#1a1a1a;color:#fff;font-size:11px;line-height:18px;text-align:center;font-style:normal}',
    '.fake_item_shape .slot-swatches{display:flex;gap:4px}',
    '.volta-pack-hint{font-size:12px;opacity:.7;margin:8px 0 0}',
    '.volta-preview{position:absolute;z-index:3;display:none;pointer-events:none;overflow:hidden}',
    '.volta-preview.is-on{display:block}',
    '.volta-preview img{width:100%;height:100%;object-fit:cover;display:block}'
  ].join('');
  document.head.appendChild(style);
  if (selectedItemFlex && selectedItemFlex.previousElementSibling && selectedItemFlex.previousElementSibling.classList.contains('custom_bundle_heading')) {
    selectedItemFlex.previousElementSibling.classList.add('volta-pack-heading');
  }
  let hintEl = null;
  if (selectedItemFlex) {
    hintEl = document.createElement('p');
    hintEl.className = 'volta-pack-hint';
    selectedItemFlex.after(hintEl);
  }

  // ---------- variantes (código original: >250 variantes via Storefront API) ----------
  const _storefrontToken = window.bundleStorefrontToken;
  const _productId = window.featureProduct && window.featureProduct.id;
  if (_storefrontToken && _productId) {
    (async function fetchRemainingVariants() {
      let cursor = null;
      let hasNext = true;
      const existing = new Set((window.allBundleVariants || []).map(v => v.id));
      while (hasNext) {
        const afterClause = cursor ? `, after: "${cursor}"` : '';
        const query = `{ product(id: "gid://shopify/Product/${_productId}") { variants(first: 250${afterClause}) { pageInfo { hasNextPage endCursor } edges { node { id availableForSale selectedOptions { value } } } } } }`;
        try {
          const res = await fetch('/api/2024-01/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': _storefrontToken },
            body: JSON.stringify({ query })
          });
          const json = await res.json();
          const variantsData = json.data && json.data.product && json.data.product.variants;
          if (!variantsData) break;
          variantsData.edges.forEach(e => {
            const numId = parseInt(e.node.id.split('/').pop());
            if (!existing.has(numId)) {
              existing.add(numId);
              window.allBundleVariants = window.allBundleVariants || [];
              window.allBundleVariants.push({ id: numId, options: e.node.selectedOptions.map(o => o.value), available: e.node.availableForSale });
            }
          });
          hasNext = variantsData.pageInfo.hasNextPage;
          cursor = variantsData.pageInfo.endCursor;
        } catch(e) { break; }
      }
      rematchAllSlots();
    })();
  }

  function allVariants() {
    if (window.allBundleVariants && window.allBundleVariants.length > 0) return window.allBundleVariants;
    return window.featureProduct ? window.featureProduct.variants : [];
  }

  function findVariantForSlot(slotOpts) {
    return allVariants().find(variant =>
      variant.options.every((val, idx) => slotOpts[idx + 1] === val)
    ) || null;
  }

  function sizeOpts() {
    const out = {};
    document.querySelectorAll('.bundle-size-select').forEach(s => { out[parseInt(s.dataset.optionPosition)] = s.value; });
    return out;
  }

  function rematchAllSlots() {
    document.querySelectorAll('.fake_item_shape .slot-swatches').forEach(container => {
      const circles = container.querySelectorAll('.slot-swatch-circle[data-option-value]');
      if (!circles.length) return;
      const slotOpts = Object.assign({}, sizeOpts());
      circles.forEach(c => { slotOpts[parseInt(c.dataset.optionPos)] = c.dataset.optionValue; });
      const matched = findVariantForSlot(slotOpts);
      if (matched) container.setAttribute('data-product_var', matched.id); else container.removeAttribute('data-product_var');
    });
    updateSelectedVariants();
  }

  // ---------- disponibilidade (código original) ----------
  function checkCombinationAvailability() {
    if (!window.featureProduct) return;
    const variants = allVariants();
    const currentOpts = {};
    Object.entries(selectedOptions).forEach(([pos, data]) => { currentOpts[parseInt(pos)] = data.value; });

    document.querySelectorAll('.bundle-size-select').forEach(sel => {
      const sizePos = parseInt(sel.dataset.optionPosition);
      const colorPositions = Object.keys(currentOpts).map(Number).filter(p => p !== sizePos);
      const allColorsSelected = colorPositions.length >= document.querySelectorAll('.bundle-options-container .colors_main_container').length;
      if (!allColorsSelected) return;
      Array.from(sel.options).forEach(opt => {
        const testOpts = { ...currentOpts, [sizePos]: opt.value };
        const matched = variants.find(v => v.options.every((val, idx) => testOpts[idx + 1] === val));
        opt.disabled = matched ? !matched.available : false;
        opt.style.color = (matched && !matched.available) ? '#bbb' : '';
      });
      if (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled) {
        const firstAvail = Array.from(sel.options).find(o => !o.disabled);
        if (firstAvail) { sel.value = firstAvail.value; sel.dispatchEvent(new Event('change')); }
      }
    });

    const totalColorGroups = document.querySelectorAll('.bundle-options-container .colors_main_container').length;
    document.querySelectorAll('.bundle-color-swatch').forEach(swatch => {
      const optPos = parseInt(swatch.dataset.optionIndex);
      const swatchValue = swatch.title;
      const otherColorsSelected = Object.keys(currentOpts).filter(p => {
        const isSizeOpt = !!document.querySelector('.bundle-size-select[data-option-position="' + p + '"]');
        return !isSizeOpt && parseInt(p) !== optPos;
      }).length;
      if (otherColorsSelected < totalColorGroups - 1) {
        swatch.classList.remove('swatch-unavailable');
        return;
      }
      const testOpts = { ...currentOpts, [optPos]: swatchValue };
      const matchedVariant = variants.find(v =>
        Object.entries(testOpts).every(([pos, val]) => v.options[parseInt(pos) - 1] === val)
      );
      const isUnavailable = matchedVariant !== undefined && !matchedVariant.available;
      swatch.classList.toggle('swatch-unavailable', isUnavailable);
    });
  }

  // ---------- imagem por cor (código original de procura; o destino passa a ser a galeria) ----------
  function getBundleMediaMaps() {
    var mapKey = Object.keys(window).find(function (k) { return k.indexOf('__voltaMediaMap_') === 0; });
    var srcKey = Object.keys(window).find(function (k) { return k.indexOf('__voltaMediaSrc_') === 0; });
    return { mediaMap: mapKey ? window[mapKey] : null, srcMap: srcKey ? window[srcKey] : null };
  }
  function findBundleMedia(productPrefix, colorValue, mediaMap) {
    if (!mediaMap) return null;
    var needleColor = colorValue.toLowerCase().trim();
    var prefixWords = productPrefix.toLowerCase().trim().split(/\s+/);
    for (var i = 0; i < prefixWords.length; i++) {
      var np = prefixWords.slice(i).join(' ');
      for (var id in mediaMap) {
        var a = (mediaMap[id] || '').trim();
        if (a.indexOf(np) !== -1 && a.endsWith(needleColor)) return id;
      }
    }
    for (var j = 0; j < prefixWords.length; j++) {
      var np2 = prefixWords.slice(j).join(' ');
      for (var id2 in mediaMap) {
        var a2 = (mediaMap[id2] || '').trim();
        if (a2.indexOf(np2) !== -1 && a2.indexOf(needleColor) !== -1) return id2;
      }
    }
    return null;
  }
  function imageFor(swatchEl) {
    const optPos = parseInt(swatchEl.dataset.optionIndex);
    const value = swatchEl.title;
    let imgSrc = null;
    const optionName = window.featureProduct && window.featureProduct.options && window.featureProduct.options[optPos - 1];
    if (optionName) {
      const prefix = optionName.toLowerCase().replace(/\s*\(?\s*colou?r\s*\)?\s*$/i, '').trim();
      const maps = getBundleMediaMaps();
      const mediaId = findBundleMedia(prefix, value, maps.mediaMap);
      if (mediaId && maps.srcMap) imgSrc = maps.srcMap[mediaId];
    }
    if (!imgSrc) imgSrc = swatchEl.dataset.image;
    if (!imgSrc && window.featureProduct && window.featureProduct.variants) {
      const matched = window.featureProduct.variants.find(v => v.options[optPos - 1] === value && v.featured_image);
      if (matched && matched.featured_image) imgSrc = matched.featured_image.src;
    }
    return imgSrc || null;
  }

  // ---------- pré-visualização sobre a galeria (as miniaturas nunca mudam) ----------
  const gallery = document.querySelector('media-gallery');
  const sliderComponent = gallery ? gallery.querySelector('slider-component') : null;
  const viewport = gallery ? gallery.querySelector('.slider__viewport') : null;
  let previewEl = null;
  function showPreview(src) {
    if (!src || !sliderComponent || !viewport) return;
    if (!previewEl) {
      previewEl = document.createElement('div');
      previewEl.className = 'volta-preview';
      previewEl.innerHTML = '<img alt="">';
      if (getComputedStyle(sliderComponent).position === 'static') sliderComponent.style.position = 'relative';
      sliderComponent.appendChild(previewEl);
      const hide = () => hidePreview();
      gallery.addEventListener('click', e => { if (e.target.closest('.thumbnail-list__item, [id^="GalleryThumbnails"], .slider-button, .slider-counter')) hide(); });
      viewport.addEventListener('scroll', hide, { passive: true });
      gallery.querySelectorAll('[id^="Slider-Gallery-"]').forEach(el => el.addEventListener('scroll', hide, { passive: true }));
      gallery.addEventListener('touchmove', hide, { passive: true });
      window.addEventListener('resize', () => { if (previewEl.classList.contains('is-on')) placePreview(); });
    }
    const img = previewEl.querySelector('img');
    if (img.getAttribute('src') !== src) img.src = src;
    placePreview();
    previewEl.classList.add('is-on');
  }
  function placePreview() {
    if (!previewEl) return;
    const slide = viewport.querySelector('li[data-media-id]:not(.volta-media-hidden)');
    const ref = slide || viewport;
    const r = ref.getBoundingClientRect(), base = sliderComponent.getBoundingClientRect();
    previewEl.style.left = (r.left - base.left) + 'px';
    previewEl.style.top = (r.top - base.top) + 'px';
    previewEl.style.width = r.width + 'px';
    previewEl.style.height = r.height + 'px';
    previewEl.style.borderRadius = slide ? getComputedStyle(slide).borderRadius : '0';
  }
  function hidePreview() { if (previewEl) previewEl.classList.remove('is-on'); }

  // ---------- selects de tamanho (código original) ----------
  document.querySelectorAll('.bundle-size-select').forEach(sel => {
    const pos = parseInt(sel.dataset.optionPosition);
    selectedOptions[pos] = { value: sel.value, swatchStyle: '' };
    sel.addEventListener('change', () => {
      selectedOptions[pos] = { value: sel.value, swatchStyle: '' };
      checkCombinationAvailability();
      rematchAllSlots();
    });
  });

  // ---------- slots ----------
  const colorGroups = Array.from(document.querySelectorAll('.bundle-options-container .colors_main_container'));
  function groupPos(group) {
    const sw = group.querySelector('.bundle-color-swatch');
    return sw ? parseInt(sw.dataset.optionIndex) : null;
  }
  function defaultSwatch(group) {
    return group.querySelector('.bundle-color-swatch.active-swatch')
      || Array.from(group.querySelectorAll('.bundle-color-swatch')).find(s => !s.classList.contains('swatch-unavailable') && !(s.parentElement && s.parentElement.classList.contains('var_disale')))
      || group.querySelector('.bundle-color-swatch');
  }
  function currentColorOpts() {
    // garante uma cor por grupo (predefinição = primeira disponível)
    const opts = {}, styles = {};
    colorGroups.forEach(group => {
      const pos = groupPos(group); if (pos == null) return;
      if (!selectedOptions[pos]) {
        const sw = defaultSwatch(group);
        if (sw) { selectedOptions[pos] = { value: sw.title, swatchStyle: sw.style.cssText }; sw.classList.add('active-swatch'); }
      }
      if (selectedOptions[pos]) { opts[pos] = selectedOptions[pos].value; styles[pos] = selectedOptions[pos].swatchStyle; }
    });
    return { opts, styles };
  }
  function buildSlots(qty) {
    const cur = currentColorOpts();
    slots = [];
    for (let i = 0; i < qty; i++) slots.push({ opts: Object.assign({}, cur.opts), styles: Object.assign({}, cur.styles) });
    activeSlot = 0; uniform = true;
    renderSlots();
  }
  function renderSlots() {
    selectedItemContainer.innerHTML = '';
    slots.forEach((slot, i) => {
      const el = document.createElement('div');
      el.className = 'fake_item_shape' + (i === activeSlot ? ' is-active' : '');
      el.setAttribute('data-number', i + 1);
      el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', T.item + ' ' + (i + 1) + ': ' + Object.values(slot.opts).join(' / '));
      const idx = document.createElement('index'); idx.textContent = i + 1; el.appendChild(idx);
      const sws = document.createElement('div'); sws.className = 'slot-swatches';
      Object.keys(slot.opts).map(Number).sort((a, b) => a - b).forEach(pos => {
        const c = document.createElement('div');
        c.className = 'slot-swatch-circle';
        c.dataset.optionPos = pos; c.dataset.optionValue = slot.opts[pos];
        c.style.cssText = slot.styles[pos] || '';
        c.title = slot.opts[pos];
        sws.appendChild(c);
      });
      const matched = findVariantForSlot(Object.assign({}, sizeOpts(), slot.opts));
      if (matched) sws.setAttribute('data-product_var', matched.id);
      el.appendChild(sws);
      el.addEventListener('click', () => setActiveSlot(i));
      el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveSlot(i); } });
      selectedItemContainer.appendChild(el);
    });
    if (sectionBlock) sectionBlock.classList.toggle('volta-pack-single', slots.length < 2);
    if (hintEl) {
      if (slots.length < 2) hintEl.textContent = '';
      else if (uniform) hintEl.textContent = colorGroups.length > 1 ? T.uniformN : T.uniform1.replace('{c}', Object.values(slots[0].opts)[0] || '');
      else hintEl.textContent = T.pick;
    }
    updateSelectedVariants();
  }
  function setActiveSlot(i) {
    voltaTrackOnce('slot', 'pack_slot_edit');
    activeSlot = i; uniform = false;
    // as swatches passam a refletir o slot ativo
    colorGroups.forEach(group => {
      const pos = groupPos(group); if (pos == null) return;
      const value = slots[i].opts[pos];
      group.querySelectorAll('.bundle-color-swatch').forEach(s => s.classList.toggle('active-swatch', s.title === value));
      const sw = group.querySelector('.bundle-color-swatch.active-swatch');
      if (sw) selectedOptions[pos] = { value: sw.title, swatchStyle: sw.style.cssText };
    });
    checkCombinationAvailability();
    renderSlots();
  }
  function applyColor(swatchEl) {
    const pos = parseInt(swatchEl.dataset.optionIndex);
    const group = swatchEl.closest('.colors_main_container');
    if (group) group.querySelectorAll('.variant_featured_image_bundle').forEach(s => s.classList.remove('active-swatch'));
    swatchEl.classList.add('active-swatch');
    selectedOptions[pos] = { value: swatchEl.title, swatchStyle: swatchEl.style.cssText };
    if (uniform) {
      slots.forEach(slot => { slot.opts[pos] = swatchEl.title; slot.styles[pos] = swatchEl.style.cssText; });
    } else if (slots[activeSlot]) {
      slots[activeSlot].opts[pos] = swatchEl.title; slots[activeSlot].styles[pos] = swatchEl.style.cssText;
    }
    checkCombinationAvailability();
    renderSlots();
    showPreview(imageFor(swatchEl));
  }

  function updateSelectedVariants() {
    window.selectedVariants = Array.from(
      document.querySelectorAll('.fake_item_shape [data-product_var]')
    ).map(el => el.getAttribute('data-product_var'));
  }

  // ---------- pacotes ----------
  const activePack = document.querySelector('.Qty__buttons.active');
  const initialQty = activePack ? parseInt(activePack.dataset.qty) : 1;
  if (qtyToCart) qtyToCart.value = initialQty;
  buildSlots(initialQty);
  if (activePack) updatePrices(activePack);

  bundlePack.forEach(pack => {
    pack.addEventListener('click', () => {
      bundlePack.forEach(p => p.classList.remove('active'));
      pack.classList.add('active');
      const dataQty = parseInt(pack.dataset.qty);
      if (qtyToCart) qtyToCart.value = dataQty;
      buildSlots(dataQty);
      hideBuyMore();
      updatePrices(pack);
      voltaTrack('pack_qty_changed', 'pack_qty', dataQty);
    });
  });

  // ---------- cores ----------
  productColors.forEach(swatchEl => {
    swatchEl.addEventListener('click', () => {
      if (swatchEl.classList.contains('swatch-unavailable')) return;
      applyColor(swatchEl);
    });
  });

  // ---------- add to cart (código original, com textos traduzidos) ----------
  const bundleCartBtn = document.querySelector('#bundle-add-to-cart');
  if (bundleCartBtn) {
    bundleCartBtn.addEventListener('click', function () {
      rematchAllSlots();
      const computed = [];
      document.querySelectorAll('.fake_item_shape .slot-swatches').forEach(container => {
        const circles = container.querySelectorAll('.slot-swatch-circle[data-option-value]');
        if (!circles.length) return;
        const slotOpts = Object.assign({}, sizeOpts());
        circles.forEach(c => { slotOpts[parseInt(c.dataset.optionPos)] = c.dataset.optionValue; });
        const matched = findVariantForSlot(slotOpts);
        if (matched) computed.push(matched.id);
      });

      if (!computed.length) { voltaTrack('pack_blocked', 'pack_blocked_reason', 'choose_all'); alert(T.chooseAll); return; }
      const expectedQty = qtyToCart ? parseInt(qtyToCart.value) : 1;
      if (computed.length < expectedQty) { voltaTrack('pack_blocked', 'pack_blocked_reason', 'unavailable'); alert(T.unavailable); return; }
      const items = computed.map(id => ({ id: parseInt(id), quantity: 1 }));
      bundleCartBtn.disabled = true;
      bundleCartBtn.textContent = bundleCartBtn.dataset.labelAdding || 'Adding...';
      const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => { if (!r.ok) return r.json().then(e => Promise.reject(e)); return r.json(); })
        .then(() => fetch(ROOT + '?sections=cart-drawer'))
        .then(r => r.json())
        .then(sections => {
          voltaTrack('pack_added', 'pack_added_qty', items.length);
          if (sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            const currentDrawer = document.querySelector('#CartDrawer');
            if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
          }
          fetch(ROOT + 'cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll('.cart-icon-bubble-count').forEach(el => { el.textContent = cart.item_count; });
          });
          const cartDrawerEl = document.querySelector('cart-drawer');
          const overlay = document.querySelector('body > .overlay');
          if (cartDrawerEl) {
            cartDrawerEl.classList.add('animate', 'active');
            if (overlay) overlay.classList.add('open');
            document.body.classList.add('hidden');
          }
          bundleCartBtn.disabled = false;
          bundleCartBtn.textContent = bundleCartBtn.dataset.labelCart || 'Add to cart';
        })
        .catch(err => {
          voltaTrack('pack_error');
          console.error('[Bundle] Cart add error:', err);
          alert(T.cartError + (err && err.description ? err.description : JSON.stringify(err)));
          bundleCartBtn.disabled = false;
          bundleCartBtn.textContent = bundleCartBtn.dataset.labelCart || 'Add to cart';
        });
    });
  }
});
